export default "__VITE_ASSET__Bn6iE66W__"